import { apiFetch } from "./client";

export interface Artifact {
  id: string;
  companyId: string;
  agentId: string | null;
  issueId: string | null;
  runId: string | null;
  name: string;
  mimeType: string;
  sizeBytes: number | null;
  storageBackend: string | null;
  storageRef: string | null;
  webUrl: string | null;
  metadata: Record<string, unknown> | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateArtifactInput {
  companyId: string;
  agentId?: string;
  issueId?: string;
  runId?: string;
  name: string;
  mimeType: string;
  sizeBytes?: number;
  storageBackend?: string;
  storageRef?: string;
  metadata?: Record<string, unknown>;
}

export interface ExportArtifactInput {
  driveId: string;
  folderPath: string;
  accessToken: string;
}

export interface ExportArtifactResult {
  success: boolean;
  artifact: Artifact;
  sharepoint: {
    driveItemId: string;
    webUrl: string;
  };
}

export const artifactsApi = {
  list: (companyId: string) =>
    apiFetch<Artifact[]>(`/artifacts?companyId=${companyId}`),
  get: (id: string) =>
    apiFetch<Artifact>(`/artifacts/${id}`),
  create: (data: CreateArtifactInput) =>
    apiFetch<Artifact>("/artifacts", {
      method: "POST",
      body: JSON.stringify(data),
    }),
  export: (id: string, data: ExportArtifactInput) =>
    apiFetch<ExportArtifactResult>(`/artifacts/${id}/export`, {
      method: "POST",
      body: JSON.stringify(data),
    }),
  delete: (id: string) =>
    apiFetch<{ success: boolean }>(`/artifacts/${id}`, {
      method: "DELETE",
    }),
};
